const isExtractDataLoading = (state) => state.isLoading;
const extractDataHasError = (state) => !!state.error;
const extractDataError = (state) => state.error;

export const getters = {
  isExtractDataLoading,
  extractDataHasError,
  extractDataError,
};
